<ms-my-bets-pair-game-scoreboard class="mybets-scoreboard_soccer" [vm]="vm">
    <ms-my-bets-scoreboard-players-pair players [vm]="vm">
        @if (!vm.isExpanded) {
            <ms-my-bets-scoreboard-soccer-red-card player1_indicators [cardsCount]="vm.redCards.player1" />
        }
        <ms-my-bets-scoreboard-soccer-goal player1_indicators [score]="vm.score.player1" />

        @if (!vm.isExpanded) {
            <ms-my-bets-scoreboard-soccer-red-card player2_indicators [cardsCount]="vm.redCards.player2" />
        }
        <ms-my-bets-scoreboard-soccer-goal player2_indicators [score]="vm.score.player2" />
    </ms-my-bets-scoreboard-players-pair>
    <ms-my-bets-pair-scoreboard-stats
        stats
        [vm]="vm.stats"
        [isExpanded]="vm.isExpanded"
        [isExpandable]="true"
        (isExpandedChanged)="isExpandedChanged($event)" />
</ms-my-bets-pair-game-scoreboard>
